import React from "react";
import { ErrorPage} from "../components";

export default function ErrorPageSection(props) {
  return (
    <div>
    <ErrorPage>
    <ErrorPage.Heading>404</ErrorPage.Heading>
    <ErrorPage.SubHeading>Page Not Found</ErrorPage.SubHeading>
         <ErrorPage.ButtonLink href='/'>Back To VMS</ErrorPage.ButtonLink>
    </ErrorPage>
    </div>
  );
}
